import { createAction } from 'redux-actions';

export const clearInventoryItems = createAction('CLEAR_INVENTORY_ITEMS');

export const clearInventoryItemsAvailability = createAction(
  'CLEAR_INVENTORY_ITEMS_AVAILABILITY'
);

export const inventoryItemsOnChangePage = createAction(
  'INVENTORY_ITEMS_ON_CHANGE_PAGE'
);

export const inventoryItemsOnChangeOrder = createAction(
  'INVENTORY_ITEMS_ON_CHANGE_ORDER'
);

export const inventoryItemsAvailabilityOnChangePage = createAction(
  'INVENTORY_ITEMS_AVAILABILITY_ON_CHANGE_PAGE'
);

export const inventoryItemsAvailabilityOnChangeOrder = createAction(
  'INVENTORY_ITEMS_AVAILABILITY_ON_CHANGE_ORDER'
);

export const resetInventoryItemDeleted = createAction(
  'RESET_INVENTORY_ITEM_DELETED'
);
